// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"136":"6488d0c4","169":"6488d0c4"}[chunkId] + ".css";
};